import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';

export default function ActionModalContent({
  bodyIcon,
  bodyText,
  bodyTitle,
  closeButtonText,
  closeModal,
  closeable,
  headerText,
  iconStyling,
  modifiers,
  withHeader,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div
      className={classNames(
        'action-modal__box',
        'tw-bg-white',
        modifiers
          ?.map((modifier) => `action-modal__box--${modifier}`)
          .join(' '),
      )}
    >
      {withHeader && (
        <section className='action-modal__header truncated-text-container tw-border-grey-100 tw-text-l tw-font-semibold tw-text-grey-900'>
          {headerText}
        </section>
      )}
      <section className='action-modal__body'>
        <span className={classNames('action-modal__icon', iconStyling)}>
          {bodyIcon}
        </span>
        <div className='action-modal__body--title tw-text-l tw-font-semibold tw-text-grey-900'>
          {bodyTitle}
        </div>
        <div className='action-modal__body--text'>{bodyText}</div>
      </section>
      {closeable && (
        <section className='action-modal__footer tw-border-grey-100'>
          <TextButton color='blue' onClick={closeModal} size='md'>
            {closeButtonText || i18nTShared('close')}
          </TextButton>
        </section>
      )}
    </div>
  );
}

ActionModalContent.defaultProps = {
  closeable: true,
  withHeader: true,
};

ActionModalContent.propTypes = {
  headerText: PropTypes.string,
  bodyIcon: PropTypes.object,
  bodyTitle: PropTypes.string,
  bodyText: PropTypes.string,
  closeable: PropTypes.bool,
  closeModal: PropTypes.func,
  modifiers: PropTypes.array,
  iconStyling: PropTypes.string,
};
